import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SustainabilityEntryModule } from '../sustainability-entry/sustainability-entry.module';
import { SharedModule } from 'app/shared/shared.module';
import { SustainabilityComponent } from './sustainability.component';

@NgModule({
  declarations: [
    SustainabilityComponent  ],
  imports: [
    CommonModule,
    SustainabilityEntryModule,
    SharedModule
  ]
})
export class SustainabilityModule { }
